import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import React from 'react';
import checkCircleTokens from '@amzn/meridian-tokens/base/icon/check-circle';
import closeCircleTokens from '@amzn/meridian-tokens/base/icon/close-circle';
import editTokens from '@amzn/meridian-tokens/base/icon/edit';
import plusTokens from '@amzn/meridian-tokens/base/icon/plus';
import trashTokens from '@amzn/meridian-tokens/base/icon/trash';

const TableActionButtons = ({
  editable = true,
  removable = true,
  onEdit,
  onDiscardEdits,
  onSave,
  onRemove,
  row,
  column,
}) => {
  return (
    <>
      {editable && (
        <Button className={row.original.isEdit ? 'd-none' : 'mr-1'} onClick={() => onEdit(row)}>
          {row.original.isNew ? <Icon tokens={plusTokens} /> : <Icon tokens={editTokens} />}
        </Button>
      )}
      <Button
        className={row.original.isEdit ? 'mr-1' : 'd-none'}
        onClick={() => onSave(row)}
        disabled={!row.original.isValid}
      >
        <Icon tokens={checkCircleTokens} />
      </Button>
      {editable && (
        <Button className={row.original.isEdit ? 'mr-1' : 'd-none'} onClick={() => onDiscardEdits(row)}>
          <Icon tokens={closeCircleTokens} />
        </Button>
      )}
      {row.original.isNew
        ? null
        : removable && (
            <Button className="mr-1" onClick={() => onRemove(row)}>
              <Icon tokens={trashTokens} />
            </Button>
          )}
    </>
  );
};

export default TableActionButtons;
